import selectTriggerElement from "./frontend/previewSelection/selectTriggerElement";

import randomAbTest from "./backend/randomAbTest";

import tracking from "./frontend/pageTracking/pageTracking";

import helpers from "./helper/helpers";

import config from "./config/config";
/* Get AB Test Page is called from the backend after fetching the page from elastic. Switches Page to an AB Test version */
let getAbTestPage = (page, overrideTestIndex, isPreview) => {
	if (!import.meta.client && overrideTestIndex === undefined) return page;

	if (randomAbTest.detectIfValidTest(page) || isPreview) page = randomAbTest.getTestPage(page, overrideTestIndex);

	return page;
};

/* Switch page to given AB test page version if found */
let switchPageToABTestPage = (page, testIndex) => {
	return helpers.switchToTest(page, testIndex);
};

const abTestPath = (testIndex) => {
	return helpers.abTestPathFound(testIndex);
};

/* Detect if vue page object contains an AB test object */
const vuePageIsAbTest = (page) => {
	return page && typeof page[config.vuePageObject] === "object";
};

/* Frontend is called when the page is loaded with an AB Test. Setup tracking */
const frontend = (pageObject, adobeTracking) => {
	helpers.onLoad(() => tracking.init(pageObject, adobeTracking));
};

/* Select Trigger Element is used from Gizmo when selecting the element to track. Global Trigger is set from _.vue in tnweb-nuxt*/
/* testType: 0 => Link tracking, testType: 1 => Component tracking */
const initGobalSelectTriggerElement = (productionOrigin, testType) => {
	helpers.onLoad(() => selectTriggerElement.initGobalSelectTriggerElement(productionOrigin, testType));
};
/* Select Trigger Element is used from Gizmo when selecting the element to track. Link Trigger is set from GizmoLink.vue in tnweb-nuxt */
const initGizmoLinkSelectTriggerElement = (event, href, productionOrigin) => {
	helpers.onLoad(() => selectTriggerElement.initGizmoLinkSelectTriggerElement(event, href, productionOrigin));
};

export default {
	getAbTestPage,
	switchPageToABTestPage,
	abTestPath,
	vuePageIsAbTest,
	frontend,
	initGobalSelectTriggerElement,
	initGizmoLinkSelectTriggerElement,
};
